'use strict';

var _ = require('lodash');
var Marionette = require('backbone.marionette');
var tpl = require('actions/staticHostMapping/formHostMapping.html');
var twig = require('twig').twig;
var tplHelpers = require('lib/tplHelpers');
var RenderChanges = require('lib/behaviors/RenderChanges');
require('lib/jquery/bootstrapUI');

/**
 * Renders the editable form elements for a single static host mapping
 */
module.exports = Marionette.View.extend({
  /**
   * @name actions/staticHostMapping/FormView#model
   * @type {actions/staticHostMapping/Reservation}
   */

  behaviors: [{
    behaviorClass: RenderChanges,
  }],

  template: twig({data: tpl}),

  ui: {
    hostname: '[name="hostname"]',
    ip: '[name="ip"]',
    remove: '.btn-remove',
    messages: '.help-block',
  },

  events: {
    'blur @ui.hostname': 'updateModel',
    'blur @ui.ip': 'updateModel',
    'click @ui.remove': 'handleRemoveButton',
  },

  modelEvents: {
    'change:remove': 'render',
    'invalid': 'onError',
    'noConflicts': 'onNoConflicts',
  },

  /**
   * @returns {Object}
   */
  templateContext: function() {
    var context = {};
    return _.extend(context, tplHelpers.apply(this));
  },

  /**
   * Sync changes in UI input elements to the model and trigger validation
   *
   * @param {Object} event
   */
  updateModel: function(event) {
    var name = event.currentTarget.name;
    var value = event.currentTarget.value;

    switch (name) {
      case 'hostname':
        this.clearError('hostname');
        this.model.set({hostname: value}, {commit: true});
        break;

      case 'ip':
        this.clearError('ip');
        this.model.set({ip: value}, {commit: true});
        break;

      default:
        break;
    }
  },

  /**
   * Remove this reservation
   */
  handleRemoveButton: function() {
    if (this.model.isNew()) {
      // remove never-saved rules immediately
      this.model.collection.remove(this.model);
    } else {
      var shouldRemove = !this.model.get('remove');
      if (shouldRemove) {
        // if you ask to remove an existing reservation, roll back any local changes
        this.model.applySnapshot();
      }
      this.model.set({remove: shouldRemove});
    }
  },

  /**
   * Decorates the view to indicate error.
   *
   * @param {Object} model
   * @param {Object} error
   * @param {Object} options
   */
  onError: function(model, error, options) {
    var self = this;
    Object.keys(error).forEach(function(key) {
      var value = error[key];
      self.ui[key].bs3ui('showGroupedFieldError', value, key, self.ui.messages);
    });
  },

  /**
   * Remove an error message from the view (if present)
   *
   * @param {String} key
   *   Identifier for the error message
   */
  clearError: function(key) {
    this.ui[key].bs3ui('clearGroupedFieldError', key, this.ui.messages);
  },

  /**
   * Clear any "special" errors related to domain conflicts
   */
  onNoConflicts: function() {
    this.clearError('hostname');
  },
});
